import { themeQuartz, iconSetMaterial } from 'ag-grid-enterprise';

const gridTheme = themeQuartz.withPart(iconSetMaterial).withParams({
  accentColor: '#6db33d',
  borderWidth: '2px',
  browserColorScheme: 'light',
  fontFamily: 'Poppins, sans-serif',
  headerBackgroundColor: '#efefef',
  headerFontSize: '0.875rem',
  rowHoverColor: '#efefef',
  borderRadius: '0.2rem',
  cellEditingShadow: 'none',
  inputBorderRadius: '0.2rem',
  focusShadow: 'none',
  selectCellBorder: ' 0.2rem solid #6db33d',
  backgroundColor: '#fafafa',
  inputFocusShadow: 'none',
  cellEditingBorder: 'none',
  wrapperBorderRadius: '0.2rem',
  footerRowBorder: 'none',
  wrapperBorder: '1px solid #efefef',
  rowBorder: '2px solid #efefef',
  headerRowBorder: '2px solid #efefef',
  borderColor: '#efefef',
  iconColor: '#6db33d',
  iconSize: '1rem',
  rowHeight: '2rem',
  dropdownShadow:
    '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
});
export const AG_GRID_THEME = gridTheme;
